/**
 * Creates array with value repeated n times.
 *
 * @param expr - Value to repeat
 * @param n - Number of repetitions (default: 1)
 * @returns Array with repeated value
 *
 * @example
 * ```ts
 * import { repeat } from "@pdfking/rfunc"
 *
 * repeat(1) // [1]
 * repeat(1, 3) // [1, 1, 1]
 * repeat(1, 0) // []
 * ```
 */
export const repeat = (expr, n = 1) => {
  const arr = []
  for (let i = 1; i <= n; i++) {
    arr.push(expr)
  }
  return arr
}
